import { Box, Button } from '@mui/material'
import {styled} from '@mui/material'
import { useEffect } from 'react';
import { useInterestedFilterStore } from 'src/stores/InterestedStore';


// 필터 버튼 스타일
const FilterButton = styled(Button)(({ theme }) => ({
    margin: "5px",
    borderRadius: "20px",
    '&.selected': {
    backgroundColor: "rgba(57, 185, 91, 0.05)", // #39B95B의 5% 투명도 적용
    color: 'rgba(6, 121, 155, 1)',                        // 테두리와 글씨 색상
    border: '1px solid rgba(6, 121, 155, 1)'         // 테두리 색상
    },
    '&.unselected': {
    backgroundColor: 'white',
    color: 'black',
    border: `1.5px solid ${theme.palette.grey[400]}`,
    },
}));

const TitleWrapper = styled('span')(({theme})=>({
    fontSize:'16px',
    fontWeight:500,
}))

const ToggleTagGender = () => {
    const temp_gender = useInterestedFilterStore((state)=>state.temp_gender)
    const toggleFilter = useInterestedFilterStore((state)=>state.toggleFilter)
    const syncField = useInterestedFilterStore((state)=>state.syncField)
    useEffect(()=>{
        syncField('gender','temp','base')
    },[])
        const mapGender: Record<number,string>={
        0 : '전체',
        1 : '남자',
        2 : '여자',
        }


  return (
    <>
        <TitleWrapper>
            성별
        </TitleWrapper>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: "5px", mb: 2 }}>
            {[0, 1, 2].map((note) => (
                <FilterButton
                key={note}
                onClick={() => toggleFilter("temp_gender", note, 0)}
                className={temp_gender.includes(note) ? "selected" : "unselected"}
                >
                {mapGender[note]}
                </FilterButton>
            ))}
        </Box>
    </>
  )
}

export default ToggleTagGender